module.exports = __webpack_public_path__ + "static/media/credit_back.12f7f51e.png";